import toast from "react-hot-toast";
import Footer from "../../components/footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import { VideoCardFooterIcons } from "../../assets/data/Datas";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import VideoCarousel from "../../components/home/VideoCarousel";
import { getReshare, postReshare } from "../../redux/ApiSlice/ResharedSlice";
import { BiSolidUpArrow, BiSolidDownArrow } from "react-icons/bi";
import { followUser, reshareRemove, reshareVideo, setCurrentIndexfn, getHomePageVideo, friendsFeeds, localFeeds, getWithoutLoginVideos, watchVideos } from "../../redux/ApiSlice/HomePageVideoSlice";
import { userStatusChangeOld } from "../../redux/ApiSlice/UserStatusSlice";
import { AccountProfilePosts, UserAccountFollow } from "../../redux/ApiSlice/AccountProfileSlice";
import LocationDetectModal from "../../components/Modals/locationDetectModal";
import { UserlikedVideos } from "../../redux/ApiSlice/LikedVideosSlice";
import { savedVideoList } from "../../redux/ApiSlice/SavedVideosSlice";

// Helper function to get nested object values
const getNestedValue = (obj, path) => {
    return path.split('.').reduce((current, key) => current?.[key], obj);
};

// Feed configuration for different feed types
const FEED_CONFIG = {
    'account': {
        action: 'AccountProfilePosts',
        dataPath: 'payload.data.results.posts',
        nextPath: 'payload.data.next',
        getParams: (url, profileId) => ({
            id: profileId,
            nextUrl: url,
            isLoadMore: true,
        })
    },
    'otherUser': {
        action: 'AccountProfilePosts',
        dataPath: 'payload.data.results.posts',
        nextPath: 'payload.data.next',
        getParams: (url, profileId) => ({
            id: profileId,
            nextUrl: url,
            isLoadMore: true,
        })
    },
    'liked': {
        action: 'UserlikedVideos',
        dataPath: 'payload.data.results.liked_posts',
        nextPath: 'payload.data.next',
        getParams: (url, profileId) => ({
            id: profileId,
            nextUrl: url,
            isLoadMore: true,
        })
    },
    'repost': {
        action: 'getReshare',
        dataPath: 'payload.data.results.reposts',
        nextPath: 'payload.data.next',
        getParams: (url, profileId) => ({
            id: profileId,
            nextUrl: url,
            isLoadMore: true,
        })
    },
    'saved': {
        action: 'savedVideoList',
        dataPath: 'payload.results.saved_posts',
        nextPath: 'payload.next',
        getParams: (url, profileId) => ({
            id: profileId,
            nextUrl: url,
            isLoadMore: true,
        })
    },

    'public': {
        action: 'getWithoutLoginVideos',
        dataPath: 'payload.results',
        nextPath: 'payload.next',
        getParams: (url) => url
    },
    'home': {
        action: 'getHomePageVideo',
        dataPath: 'payload.results',
        nextPath: 'payload.next',
        getParams: (url) => url
    }
};

export default function WatchVideo() {
    // Detect Chrome on iOS
    const isChromeOniOS = (() => {
        if (typeof navigator === "undefined") return false;
        const ua = navigator.userAgent;
        return /CriOS/i.test(ua) && /iphone|ipad|ipod/i.test(ua);
    })();

    const params = useParams();
    const { id, } = params;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    // Get feed type from navigation state (priority), URL params, or localStorage
    const urlParams = new URLSearchParams(window.location.search);
    const feedTypeFromState = location.state?.feedType;
    const nextPage = location.state?.nextPage;
    const feedTypeFromUrl = urlParams.get('feedType');
    const feedTypeFromStorage = localStorage.getItem('currentFeedType');
    const feedTypeParam = feedTypeFromState || feedTypeFromUrl || feedTypeFromStorage;
    const [feedType, setFeedType] = useState(feedTypeParam);
    const { from: prevPath } = location.state || {};

    // Update feedType when URL params or location state changes
    useEffect(() => {
        const newFeedType = feedTypeFromState || feedTypeFromUrl || feedTypeFromStorage || '';
        if (newFeedType !== feedType) {
            setFeedType(newFeedType);
        }
    }, [feedTypeFromState, feedTypeFromUrl, feedTypeFromStorage, feedType]);


    // const getAllPost = useSelector((state) => state.WatchVideo);
    const { videoData = [] } = useSelector((state) => state.HomePageVideo);
    const ProfileDetails = useSelector((state) => state.AccountProfile);
    const { User_profile } = ProfileDetails;

    const [posts, setPosts] = useState([]);
    const [showWelcome, setShowWelcome] = useState(false);
    const [isFollow, setIsFollow] = useState(false);
    const [resharedPostId, setResharedPostId] = useState(null);
    const [rehsaredMesaage, setResharedMessage] = useState(null);
    const reshareTimeoutRef = useRef(null);
    const [nextPageUrl, setNextPageUrl] = useState(nextPage || null);
    const videoIndex = videoData?.findIndex((video) => video.id === id);
    const isScrollingRef = useRef(false);
    const wheelUnlockTimeoutRef = useRef(null);

    useEffect(() => {
        if (reshareTimeoutRef.current) {
            clearTimeout(reshareTimeoutRef.current);
            reshareTimeoutRef.current = null;
        }

        if (!rehsaredMesaage) {
            return undefined;
        }

        reshareTimeoutRef.current = setTimeout(() => {
            setResharedPostId(null);
            setResharedMessage(null);
            reshareTimeoutRef.current = null;
        }, 5000);

        return () => {
            if (reshareTimeoutRef.current) {
                clearTimeout(reshareTimeoutRef.current);
                reshareTimeoutRef.current = null;
            }
        };
    }, [rehsaredMesaage]);

    const [currentIndex, setCurrentIndex] = useState(0);
    const [direction, setDirection] = useState(1);
    const [locationDetectorModal, setLocationDetectorModal] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [userLogin, setUserLogin] = useState(null);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const hasLoadedInitialData = useRef(false);
    const auth = useSelector((state) => state.auth);
    const token = auth.accessToken;

    useEffect(() => {
        setUserLogin(token);
    }, [token]);

    const handleReshared = async (postId) => {
        try {
            const response = await dispatch(postReshare({ postId }));

            if (response?.payload?.message === "Repost undone successfully!") {
                const updatedArray = posts?.map((item) => {
                    return {
                        ...item,
                        userreshared:
                            item.id === postId ? !item?.userreshared : item?.userreshared,
                    };
                });
                setPosts(updatedArray);
                setResharedPostId(postId);
                setResharedMessage("Repost Removed");
                dispatch(reshareRemove(postId));
            } else {
                const updatedArray = posts?.map((item) => {
                    return {
                        ...item,
                        userreshared:
                            item.id === postId ? !item?.userreshared : item?.userreshared,
                    };
                });
                dispatch(reshareVideo(postId));
                setPosts(updatedArray);
                setResharedPostId(postId);
                setResharedMessage("Reposted");
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleReadUserStatus = useCallback(async () => {
        try {
            const response = await dispatch(userStatusChangeOld());
            setShowWelcome(response?.payload?.new_user);
        } catch (error) {
            console.error(error);
        }
    }, [dispatch]);

    const handleFollowFun = async (id) => {
        try {
            const response = await dispatch(UserAccountFollow(id));
            const updatedArray = posts?.map((item) => {
                return {
                    ...item,
                    userfollowing:
                        item.created_by.id === id
                            ? !item?.userfollowing
                            : item?.userfollowing,
                };
            });
            setPosts(updatedArray);
            dispatch(followUser({ id }))

            setIsFollow(true);

            setTimeout(() => {
                setIsFollow(false);
            }, 2000)

            toast.success(response?.payload?.message);
        } catch (error) {
            console.error(error);
        }
    };

    // Detect screen size
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (Array.isArray(videoData) && videoData?.length > 0) {
            if (posts.length === 0 || !hasLoadedInitialData.current) {
                setPosts(videoData);
                hasLoadedInitialData.current = true;
                const index = videoData?.findIndex((video) => video.id === id);
                if (index !== -1) {
                    setCurrentIndex(index);
                }
            } else {
                const index = posts?.findIndex((video) => video.id === id);
                if (index !== -1 && index !== currentIndex) {
                    setCurrentIndex(index);
                }
            }
        } else if (!Array.isArray(videoData)) {
            setPosts([]);
            hasLoadedInitialData.current = false;
        }
    }, [id]);

    const reloadPage = () => {
        window.location.reload();
    };

    const handleRefresh = () => {
        navigate("/");
    }

    const handleNavigate = (value) => {
        const replaceValue = value.replaceAll(" ", "");
        switch (replaceValue) {
            case "Neighborhood":
                return navigate(`/neighborhood`);
            case "YourFeed":
                return reloadPage();
            case "YourFriends":
                return reloadPage();
            case "Home":
                return navigate("/");
            case "Createvideo":
                return navigate(`/create-videos`);
            case "Messages":
                return navigate(`/message`);
            case "Helmet1":
                return navigate(`/commingsoon`);
            case "Account":
                return navigate(`/account`);
            case "Groups":
                return navigate(`/othergroup/list/`);
            default:
                break;
        }
    };

    const navigateToVideo = (newIndex) => {
        const videoId = posts[newIndex]?.id;
        if (videoId) {
            navigate(`/watch/${videoId}${feedType ? `?feedType=${feedType}` : ''}`, {
                state: { feedType: feedType, nextPage: nextPageUrl, from: prevPath },
            });
        }
    };

    // Dynamic pagination based on feed type - Optimized with config approach
    const fetchMoreVideos = async (currentNextUrl) => {

        if (!currentNextUrl) {
            return null;
        }

        const config = FEED_CONFIG[feedType];

        try {
            const actionMap = {
                'AccountProfilePosts': AccountProfilePosts,
                'UserlikedVideos': UserlikedVideos,
                'getReshare': getReshare,
                'savedVideoList': savedVideoList,
                'localFeeds': localFeeds,
                'getWithoutLoginVideos': getWithoutLoginVideos,
                'getHomePageVideo': getHomePageVideo
            };

            const actionFunction = actionMap[config.action];

            if (!actionFunction) {
                console.error(`No action function found for: ${config.action} (feedType: ${feedType})`);
                return null;
            }

            const otherUserId = posts[0]?.created_by?.id || User_profile.id;
            const params = config.getParams(currentNextUrl, feedType === "otherUser" ? otherUserId : User_profile.id);

            // Dispatch the action
            const response = await dispatch(actionFunction(params));

            // Extract data using configured paths
            const newPosts = getNestedValue(response, config.dataPath);
            const nextUrl = getNestedValue(response, config.nextPath);


            // If no nextUrl, we've reached the end of pagination
            if (!nextUrl) {
            }

            // For repost type, extract original_post from each repost item
            let processedPosts = newPosts;
            if (feedType === 'repost' && Array.isArray(newPosts)) {
                processedPosts = newPosts.map(repost => repost.original_post).filter(post => post);
            }

            // Update posts state if we have new data
            if (Array.isArray(processedPosts) && processedPosts.length > 0) {
                setPosts((prevPosts) => {
                    const updatedPosts = [...prevPosts, ...processedPosts];
                    dispatch(watchVideos(updatedPosts));
                    return updatedPosts;
                });
            }

            return {
                data: processedPosts,
                nextUrl: nextUrl || null
            };
        } catch (error) {
            console.error("Error fetching more videos:", error);
            return null;
        }
    };

    const handleNext = async () => {
        const newIndex = currentIndex + 1;

        // Preload: Fetch next page when user is near the end (2 videos before last)
        if (newIndex >= posts.length - 2 && !isLoadingMore && nextPageUrl) {
            setIsLoadingMore(true);
            fetchMoreVideos(nextPageUrl)
                .then((result) => {
                    if (result && result.nextUrl) {
                        setNextPageUrl(result.nextUrl);
                    } else {
                        setNextPageUrl(null);
                    }
                })
                .catch((error) => {
                    console.error("Error preloading videos:", error);
                })
                .finally(() => {
                    setIsLoadingMore(false);
                });
        }

        // Check if trying to navigate beyond current posts
        if (newIndex >= posts.length) {
            if (isLoadingMore) {
                return;
            }

            if (!nextPageUrl) {
                toast.error("You've reached the end of the videos");
                return;
            }
        }

        setCurrentIndex(newIndex);
        setDirection(1);
        dispatch(setCurrentIndexfn(newIndex));
        navigateToVideo(newIndex);
    };

    const handlePrev = () => {
        if (currentIndex === 0) return;
        const newIndex = currentIndex - 1;
        setDirection(-1);
        setCurrentIndex(newIndex);
        dispatch(setCurrentIndexfn(newIndex));
        navigateToVideo(newIndex);
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
                if (currentIndex !== 0) {
                    handlePrev();
                }
            } else if (event.key === "ArrowRight" || event.key === "ArrowDown") {
                if (currentIndex !== posts.length - 1) {
                    handleNext();
                }
            }
        };
        const handleWheel = (event) => {
            // Prevent default scrolling behavior
            event.preventDefault();

            // Already mid-gesture (e.g. trackpad inertia still firing wheel events):
            // extend the lock instead of re-triggering, so it only releases once the
            // gesture actually stops rather than on a fixed clock from the first event.
            if (isScrollingRef.current) {
                clearTimeout(wheelUnlockTimeoutRef.current);
                wheelUnlockTimeoutRef.current = setTimeout(() => {
                    isScrollingRef.current = false;
                }, 500);
                return;
            }

            // deltaY > 0 means scrolling down, < 0 means scrolling up
            if (event.deltaY > 0) {
                // if (loading) return;
                isScrollingRef.current = true;
                handleNext();
                wheelUnlockTimeoutRef.current = setTimeout(() => {
                    isScrollingRef.current = false;
                }, 500); // released once inertial scroll settles
            } else if (event.deltaY < 0) {
                isScrollingRef.current = true;
                handlePrev();
                wheelUnlockTimeoutRef.current = setTimeout(() => {
                    isScrollingRef.current = false;
                }, 500); // released once inertial scroll settles
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("wheel", handleWheel, { passive: false });
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("wheel", handleWheel);
            clearTimeout(wheelUnlockTimeoutRef.current);
        };
    }, [currentIndex, posts]);

    return (
        <>
            <div className="hidden md:flex md:w-[10%] mr-4" />

            <div className="h-full w-full md:w-[75%] lg:w-[60%] xl:w-[55%] bg-black border-black md:border-[2px] relative md:rounded-[20px] overflow-hidden">
                <div className="h-[88%]">
                    <VideoCarousel
                        videos={posts}
                        totalVideos={posts?.length}
                        // summary={summary}
                        // spilThashTags={spilThashTags}
                        id={id}
                        handleReshared={handleReshared}
                        itsNotHome={true}
                        handleReadUserStatus={handleReadUserStatus}
                        newUser={showWelcome}
                        resharedPostId={resharedPostId}
                        rehsaredMesaage={rehsaredMesaage}
                        setResharedPostId={setResharedPostId}
                        handleFollowFun={handleFollowFun}
                        setCurrentIndex={setCurrentIndex}
                        currentIndex={currentIndex}
                        setDirection={setDirection}
                        direction={direction}
                        handleNext={handleNext}
                        handlePrev={handlePrev}
                        isMobile={isMobile}
                        isFollow={isFollow}
                        handleRefresh={handleRefresh}
                        userLogin={userLogin}
                    />
                </div>

                <div
                    style={{
                        paddingBottom: isChromeOniOS
                            ? "calc(env(safe-area-inset-bottom, 0px) + 0px)"
                            : "env(safe-area-inset-bottom)",
                    }}
                    className="h-full w-full bg-[#333333] dark:bg-[#333333]"
                >
                    <Footer
                        isFixedDark={true}
                        deactiveIcon={true}
                        handleRefresh={handleRefresh}
                        handleNavigate={handleNavigate}
                        VideoCardHeaderIcons={VideoCardFooterIcons}
                        setLocationDetectorModal={setLocationDetectorModal}
                    />
                </div>

            </div>

            <div className="hidden md:flex h-full items-center md:w-[10%] ml-4">
                <div className="flex flex-col gap-5">
                    <button
                        onClick={handlePrev}
                        disabled={currentIndex === 0 || posts?.length === 0}
                        className="disabled:opacity-50 disabled:cursor-not-allowed h-12 w-12 rounded-full bg-[#A8D7F2] text-[#365975] hover:bg-[#94CAE9] flex items-center justify-center"
                    >
                        <BiSolidUpArrow className="text-[16px]" />
                    </button>
                    <button
                        onClick={handleNext}
                        disabled={posts?.length === 0 || (currentIndex === posts.length - 1 && !nextPageUrl)}
                        className="disabled:opacity-50 disabled:cursor-not-allowed h-12 w-12 rounded-full bg-[#A8D7F2] text-[#365975] hover:bg-[#94CAE9] flex items-center justify-center"
                    >
                        <BiSolidDownArrow className="text-[16px]" />
                    </button>
                </div>
            </div>

            {locationDetectorModal && (
                <LocationDetectModal handleClose={setLocationDetectorModal} />
            )}
        </>
    );
}